import { NAME } from './constants';
import { State } from '../../common/types/types';

export const getSelectedItem = <T>(state: State): T => state[NAME].selectedItem;
export const getItems = <T>(state: State): Array<T> => state[NAME].items;
export const getSortDesc = (state: State): boolean => state[NAME].sortDesc;
export const getIsDialogOpen = (state: State): boolean =>
  state[NAME].isDialogOpen;
